import React, { memo, useEffect, useRef, useState } from "react";
import OauthPopup from "react-oauth-popup";
import { ReactComponent as SocialGIcon } from "../../../../assets/images/SocialGIcon.svg";
import {
  useSocialLoginCallbackMutation,
  useSocialLoginMutation,
} from "../../../../store/authentication/authService";

import { Container, SocialButton } from "./styles";

const AuthSocialIframeForm = ({ title }) => {
  const [url, setUrl] = useState("");
  const [social, setSocial] = useState();
  const refBtnFaceBook = useRef(null);

  const [login, { isLoading }] = useSocialLoginMutation();
  const [loginCallback] = useSocialLoginCallbackMutation();

  const onClose = () => {
    setUrl("");
    setSocial("");
  };

  const sendCode = async (code) => {
    try {
      await loginCallback({
        social,
        code,
      }).unwrap();

      setUrl("");
      setSocial("");

      try {
        window.parent.postMessage({ type: "AUTH_SUCCESS", social }, "*");
      } catch (e) {
        console.error("Cannot communicate with parent window");
      }

      setTimeout(() => {
        window.location.reload();
      }, 100);
    } catch (error) {
      setUrl("");
      setSocial("");
    }
  };

  const loginGoogle = async () => {
    try {
      setSocial("google");
      const res = await login({ social: "google" }).unwrap();

      if (res?.payload?.redirect_url) {
        setUrl(`${res?.payload?.redirect_url}&approval_prompt=force`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (url) {
      refBtnFaceBook?.current?.click();
    }
  }, [url]);

  return (
    <Container>
      <OauthPopup
        title={`${title} with Google`}
        width={600}
        height={600}
        url={url}
        onCode={sendCode}
        onClose={onClose}
      >
        <div ref={refBtnFaceBook} />
      </OauthPopup>

      <SocialButton
        onClick={loginGoogle}
        loading={isLoading && social === "google"}
        icon={<SocialGIcon />}
        color="#E22C2A"
      >
        {title} with Google
      </SocialButton>
    </Container>
  );
};

export default memo(AuthSocialIframeForm);
